/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_Scope_Always_PersonInputs */



/**
* | output |
* | --- |
* | "All conversations with {name}" |
*
* @param {Meeting_Scope_Always_PersonInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_always_person = /** @type {((inputs: Meeting_Scope_Always_PersonInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_Always_PersonInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Alle gesprekken met ${i?.name}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Toutes les conversations avec ${i?.name}`)
	return /** @type {LocalizedString} */ (`All conversations with ${i?.name}`)
});